// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth__Auth--2YUr1","AuthForm":"Auth__AuthForm--2Xb4F"};